import { useState } from 'react';
import { SecureDelete, SecureUpload } from '../services/axiosCall';
import { message } from 'antd';

const useAttachment = ({ url }) => {
    const [loading, setLoading] = useState(false);

    const upload = async (options) => {
        const { onSuccess, onError, file } = options;

        const fmData = new FormData();
        fmData.append('url', file);

        setLoading(true)

        try {
            const res = await SecureUpload({
                url: `${url}`,
                data: fmData
            })
            onSuccess(setLoading(false))
            return res.data;

        }
        catch (err) {
            console.log(err)
            const errMsg =
                err?.response?.status === 413
                    ? 'File is too large to upload.'
                    : err?.response?.data?.message || 'Upload failed. Please try again.';

            message.error(errMsg);
            onError(err instanceof Error ? err : new Error(errMsg));
            return null; // explicit signal to caller that upload failed
        } finally {
            setLoading(false)
        }
    };

    const remove = async (options) => {
        const { id } = options;

        return await SecureDelete({ url: `${url}/${id}` })
            .then(() => id)
            .catch((err) => console.log(err))
    };

    return {
        upload,
        remove,
        loading
    }
}

export default useAttachment